<div class="begin-umbrueckung-dialog">

  <div class="dialog-layout">
    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc.begin-umbrueckung-dialog.title"></sc-dictionary-label>
    </h2>


    <div class="top-info">
      <app-transport-info-panel [carrier]="details.carrier" [identifier]="details.identifier" [driver]="details.name"
      [scope]="details.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">

      <div [hidden]="currentPage !== 0">

        <sc-sub-title>
          <sc-dictionary-label dictionaryKey="tmc.begin-umbrueckung-dialog.table-header"></sc-dictionary-label>
        </sc-sub-title>

        <sc-content-spacer vertical></sc-content-spacer>

        <div class="table-container">
          <sc-tmc-table [tableModel]="tableModel" #tmcTableComponent></sc-tmc-table>
        </div>
      </div>

      <div [hidden]="currentPage !== 1">
        <sc-sub-title>
          <sc-dictionary-label
          dictionaryKey="tmc.begin-umbrueckung-dialog.remaining-transport-details.title"></sc-dictionary-label>
        </sc-sub-title>

        <sc-content-spacer vertical></sc-content-spacer>

        <div>
          <mat-form-field class="width-250" [hidden]="!isTrailerNumberVisible()" appearance="fill" class="fullSizeInput">
            <mat-label>
              <sc-dictionary-label
              dictionaryKey="tmc.begin-umbrueckung-dialog.trailerNumberPlate"></sc-dictionary-label>
            </mat-label>
            <input name="trailerNumberPlate" matInput [(ngModel)]="details.trailerNumberPlate"
              [required]="isTrailerNumberPlateRequired()" [maxlength]="255">
            </mat-form-field>
          </div>
          @if (isSwapTrailerEnabled()) {
            <div>
              <mat-form-field class="width-250" appearance="fill" class="fullSizeInput">
                <mat-label>
                  <sc-dictionary-label
                  dictionaryKey="tmc-yard.begin-umbrueckung-dialog.entity.masterdata.firstLoadCarrier.swapTrailerNumber"></sc-dictionary-label>
                </mat-label>
                <input name="swapTrailerNumber" matInput [(ngModel)]="details.swapTrailerNumber"
                  [required]="isSwapTrailerNumberRequired()" [maxlength]="255">
                </mat-form-field>
              </div>
            }

            <div class="messages">
              <app-service-response [responseMessages]="responseMessages"></app-service-response>
            </div>
          </div>

        </div>



        <sc-actionbar>
          @if (currentPage > 0) {
            <sc-back-button (click)="stepBack()"></sc-back-button>
          }
          <sc-content-spacer grow></sc-content-spacer>
          <sc-close-button (click)="closeDialog()" [disabled]="isCloseDialogDisabled()"></sc-close-button>
          <sc-content-spacer></sc-content-spacer>
          @if (currentPage == 0) {
            <sc-forward-button primary iconPosition="right" (click)="selectTargetTransport()" [disabled]="isSelectTargetTransportDisabled()"
            ></sc-forward-button>
          }
          @if (currentPage == 1) {
            <sc-button primary iconClass="fa-check" [disabled]="isBeginUmbrueckungDisabled()"
            dictionaryKey="tmc.begin-umbrueckung-dialog.action.begin" (click)="beginUmbrueckung()"></sc-button>
          }
        </sc-actionbar>

      </div>
    </div>
